import { render, staticRenderFns } from "./SkupPrijavaForma.vue?vue&type=template&id=ba30f1ac&scoped=true&"
import script from "./SkupPrijavaForma.vue?vue&type=script&lang=js&"
export * from "./SkupPrijavaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba30f1ac",
  null
  
)

export default component.exports